<template>
    <section class="the-nav p-8">
        <NuxtLink v-for="(cur, idx) of aNav" :key="idx"
            :to="useLocalePath()(cur.to)"
        >
            {{cur.name}}
        </NuxtLink>
    </section>
</template>

<script>
export default {
    data(){
        return {
            aNav: [{
                to: '/_demoGround/button',
                name: '按钮',
                desc: '',
            },{
                to: '/_demoGround/icon',
                name: '图标',
                desc: '',
            },{
                to: '/_demoGround/input',
                name: '输入框',
                desc: '',
            },{
                to: '/_demoGround/others',
                name: '其它',
                desc: '',
            }],
        };
    },
}

</script>

<style scoped lang="scss">
.the-nav{
    border-bottom: solid 1px gray;
    margin: auto 30px;
    padding: 2rem 0;
    & > *{
        margin-right: 2em;
        padding: 5px;
    }
}
.router-link-active{
    border-bottom:  solid 1px white;
}
</style>